//NOTE autogenerated by export script

export type Endpoint = {
  name: typeof ENDPOINTS[number]['name']
  method: string
  path: string
}
export const ENDPOINTS = [
  {
    "name": "dsApi.AllDevices.getDevicesByRmaIds",
    "method": "POST",
    "path": "/device-storage/devices/get-by-rma-ids"
  },
  {
    "name": "dsApi.AnimalSpeciesCustomers.get",
    "method": "GET",
    "path": "/device-storage/animal-species-customers"
  },
  {
    "name": "dsApi.BootloaderVersions.customerGetAll",
    "method": "GET",
    "path": "/device-storage/bootloader-versions/customer"
  },
  {
    "name": "dsApi.BootloaderVersions.customerGetByIds",
    "method": "POST",
    "path": "/device-storage/bootloader-versions/customer/get-by-ids"
  },
  {
    "name": "dsApi.ConfigFiles.generateDssModel",
    "method": "POST",
    "path": "/device-storage/config-files/generate-dss-model"
  },
  {
    "name": "dsApi.DeviceClasses.getDeviceClasses",
    "method": "GET",
    "path": "/device-storage/device-classes"
  },
  {
    "name": "dsApi.DeviceTypesCustomer.getDeviceTypes",
    "method": "GET",
    "path": "/device-storage/device-types"
  },
  {
    "name": "dsApi.FirmwareClasses.getAll",
    "method": "GET",
    "path": "/device-storage/firmware-classes"
  },
  {
    "name": "dsApi.FirmwareClasses.getById",
    "method": "GET",
    "path": "/device-storage/firmware-classes/{id}"
  },
  {
    "name": "dsApi.FirmwareClasses.getByIdentifiers",
    "method": "GET",
    "path": "/device-storage/firmware-classes/get-by-identifiers"
  },
  {
    "name": "dsApi.FirmwareVersions.customerGetAll",
    "method": "GET",
    "path": "/device-storage/firmware-versions/customer"
  },
  {
    "name": "dsApi.FirmwareVersions.customerGetBinary",
    "method": "GET",
    "path": "/device-storage/firmware-versions/{firmwareVersionId}/customer/download-binary"
  },
  {
    "name": "dsApi.FirmwareVersions.customerGetByIds",
    "method": "POST",
    "path": "/device-storage/firmware-versions/customer/get-by-ids"
  },
  {
    "name": "dsApi.PCBTypes.get",
    "method": "GET",
    "path": "/device-storage/pcb-types"
  },
  {
    "name": "dsApi.PCBTypes.getByIds",
    "method": "POST",
    "path": "/device-storage/pcb-types/get-by-ids"
  },
  {
    "name": "dsApi.ParameterListVersion.getCurrentParameterListVersion",
    "method": "GET",
    "path": "/device-storage/parameter-list-version"
  },
  {
    "name": "dsApi.ParametersCategories.getParameterCategories",
    "method": "GET",
    "path": "/device-storage/parameter-categories"
  },
  {
    "name": "dsApi.ParametersCustomer.getParameters",
    "method": "GET",
    "path": "/device-storage/customer/parameters"
  },
  {
    "name": "dsApi.ParametersCustomer.getParametersByIds",
    "method": "POST",
    "path": "/device-storage/customer/parameters/get"
  },
  {
    "name": "dsApi.Schedules.fromXmlString",
    "method": "POST",
    "path": "/device-storage/schedules/from-xml-string"
  },
  {
    "name": "dsApi.Schedules.toXmlString",
    "method": "POST",
    "path": "/device-storage/schedules/to-xml-string"
  },
  {
    "name": "dsApi.Subsystems.getSubsystems",
    "method": "GET",
    "path": "/device-storage/subsystems"
  },
  {
    "name": "httpApi.CurrentMaxId.getCurrentMaxId",
    "method": "GET",
    "path": "/wildlife/current-max-id"
  },
  {
    "name": "oofApi.BffOofWeb.createOrderItemConfiguration",
    "method": "POST",
    "path": "/oof-api/bff/web/orders/{orderId}/items/{orderItemId}/configurations"
  },
  {
    "name": "oofApi.BffOofWeb.deleteOrderItemConfiguration",
    "method": "DELETE",
    "path": "/oof-api/bff/web/orders/{orderId}/items/{orderItemId}/configurations/{orderConfigurationId}"
  },
  {
    "name": "oofApi.BffOofWeb.getConfigurationOverview",
    "method": "POST",
    "path": "/oof-api/bff/web/orders/config-overview"
  },
  {
    "name": "oofApi.BffOofWeb.getOrderById",
    "method": "GET",
    "path": "/oof-api/bff/web/orders/{orderId}"
  },
  {
    "name": "oofApi.BffOofWeb.getOrdersByFilter",
    "method": "POST",
    "path": "/oof-api/bff/web/orders"
  },
  {
    "name": "oofApi.BffOofWeb.updateOrder",
    "method": "PUT",
    "path": "/oof-api/bff/web/orders/{orderId}"
  },
  {
    "name": "oofApi.BffOofWeb.updateOrderItemByPosition",
    "method": "PUT",
    "path": "/oof-api/bff/web/orders/{orderId}/items/{orderItemId}"
  },
  {
    "name": "oofApi.BffOofWeb.updateOrderItemConfiguration",
    "method": "PUT",
    "path": "/oof-api/bff/web/orders/{orderId}/items/{orderItemId}/configurations/{orderConfigurationId}"
  },
  {
    "name": "oofApi.BffOofWeb.updateOrderItemConfigurationFormData",
    "method": "PUT",
    "path": "/oof-api/bff/web/orders/{orderId}/items/{orderItemId}/configurations/{orderConfigurationId}/form-data"
  },
  {
    "name": "oofApi.ConfigTemplatesCustomer.addFavoriteConfig",
    "method": "POST",
    "path": "/oof-api/bff/web/config-templates/favorites/{configId}"
  },
  {
    "name": "oofApi.ConfigTemplatesCustomer.getConfigTemplates",
    "method": "GET",
    "path": "/oof-api/bff/web/config-templates"
  },
  {
    "name": "oofApi.ConfigTemplatesCustomer.getFavoriteConfigs",
    "method": "GET",
    "path": "/oof-api/bff/web/config-templates/favorites"
  },
  {
    "name": "oofApi.ConfigTemplatesCustomer.removeFavoriteConfig",
    "method": "DELETE",
    "path": "/oof-api/bff/web/config-templates/favorites/{configId}"
  },
  {
    "name": "oofApi.MeUser.getUserAddresses",
    "method": "GET",
    "path": "/oof-api/users/me/addresses"
  },
  {
    "name": "oofApi.OrderItemConfigurations.getById",
    "method": "GET",
    "path": "/oof-api/orders/{orderId}/items/{orderItemId}/configurations/{orderConfigurationId}"
  },
  {
    "name": "oofApi.OrderItemDevices.getDevices",
    "method": "GET",
    "path": "/oof-api/orders/{orderId}/items/{orderItemId}/devices"
  },
  {
    "name": "oofApi.OrderItemDevices.setConfigurationDevices",
    "method": "PUT",
    "path": "/oof-api/orders/{orderId}/items/{orderItemId}/configurations/{orderConfigurationId}/devices"
  },
  {
    "name": "oofApi.OrderItems.getOrderItemByPosition",
    "method": "GET",
    "path": "/oof-api/orders/{orderId}/items/{orderItemId}"
  },
  {
    "name": "oofApi.Orders.getOrderById",
    "method": "GET",
    "path": "/oof-api/orders/{orderId}"
  },
  {
    "name": "oofApi.Orders.getOrdersByFilter",
    "method": "POST",
    "path": "/oof-api/orders"
  },
  {
    "name": "oofApi.RmaCustomer.addRma",
    "method": "POST",
    "path": "/oof-api/rmas"
  },
  {
    "name": "oofApi.RmaCustomer.deleteRma",
    "method": "DELETE",
    "path": "/oof-api/rmas/{rmaId}"
  },
  {
    "name": "oofApi.RmaCustomer.downloadAttachment",
    "method": "GET",
    "path": "/oof-api/rmas/{rmaId}/download-attachment"
  },
  {
    "name": "oofApi.RmaCustomer.downloadShippingInstructions",
    "method": "GET",
    "path": "/oof-api/rmas/download-shipping-instructions"
  },
  {
    "name": "oofApi.RmaCustomer.downloadSummary",
    "method": "GET",
    "path": "/oof-api/rmas/{rmaId}/download-summary"
  },
  {
    "name": "oofApi.RmaCustomer.editRma",
    "method": "PUT",
    "path": "/oof-api/rmas/{rmaId}"
  },
  {
    "name": "oofApi.RmaCustomer.getRmas",
    "method": "GET",
    "path": "/oof-api/rmas"
  },
  {
    "name": "uploadCollectorApi.WildlifeEventUpload.customerWildlifeEventUpload",
    "method": "POST",
    "path": "/uploadCollector/customer-wildlife-event-upload"
  },
  {
    "name": "userApi.APIKeys.createApiKey",
    "method": "POST",
    "path": "/user/api-keys"
  },
  {
    "name": "userApi.APIKeys.getAllApiKeys",
    "method": "GET",
    "path": "/user/api-keys"
  },
  {
    "name": "userApi.APIKeys.revokeApiKey",
    "method": "DELETE",
    "path": "/user/api-keys/{id}"
  },
  {
    "name": "userApi.AccountAndPreferences.addAddress",
    "method": "POST",
    "path": "/user/account/address"
  },
  {
    "name": "userApi.AccountAndPreferences.createUserAccount",
    "method": "POST",
    "path": "/user/account"
  },
  {
    "name": "userApi.AccountAndPreferences.editUserData",
    "method": "PUT",
    "path": "/user/account"
  },
  {
    "name": "userApi.AccountAndPreferences.getHeaderHidden",
    "method": "GET",
    "path": "/user/account/userpreferences/headerhidden"
  },
  {
    "name": "userApi.AccountAndPreferences.getUserAccount",
    "method": "GET",
    "path": "/user/account"
  },
  {
    "name": "userApi.AccountAndPreferences.getUserEmail",
    "method": "GET",
    "path": "/user/account/my-email"
  },
  {
    "name": "userApi.AccountAndPreferences.getUserPreferences",
    "method": "GET",
    "path": "/user/account/userpreferences"
  },
  {
    "name": "userApi.AccountAndPreferences.patchUserPreferences",
    "method": "PATCH",
    "path": "/user/account/userpreferences"
  },
  {
    "name": "userApi.AccountAndPreferences.putUserPreferences",
    "method": "PUT",
    "path": "/user/account/userpreferences"
  },
  {
    "name": "userApi.AccountAndPreferences.setHeaderHidden",
    "method": "PUT",
    "path": "/user/account/userpreferences/headerhidden"
  },
  {
    "name": "userApi.Animals.addGroup",
    "method": "POST",
    "path": "/user/animals/groups"
  },
  {
    "name": "userApi.Animals.addGroupShares",
    "method": "POST",
    "path": "/user/animals/groups/{id}/shares"
  },
  {
    "name": "userApi.Animals.addObject",
    "method": "POST",
    "path": "/user/animals"
  },
  {
    "name": "userApi.Animals.addObjectShares",
    "method": "POST",
    "path": "/user/animals/{id}/shares"
  },
  {
    "name": "userApi.Animals.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/animals/shares"
  },
  {
    "name": "userApi.Animals.deleteGroup",
    "method": "DELETE",
    "path": "/user/animals/groups/{id}"
  },
  {
    "name": "userApi.Animals.deleteGroupShares",
    "method": "POST",
    "path": "/user/animals/groups/{id}/shares/delete"
  },
  {
    "name": "userApi.Animals.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/animals/multiple/deletion"
  },
  {
    "name": "userApi.Animals.deleteObject",
    "method": "DELETE",
    "path": "/user/animals/{id}"
  },
  {
    "name": "userApi.Animals.deleteObjectShares",
    "method": "POST",
    "path": "/user/animals/{id}/shares/delete"
  },
  {
    "name": "userApi.Animals.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/animals/shares/delete"
  },
  {
    "name": "userApi.Animals.denyRequestedShares",
    "method": "POST",
    "path": "/user/animals/shares/requests/deny"
  },
  {
    "name": "userApi.Animals.editGroup",
    "method": "PUT",
    "path": "/user/animals/groups/{id}"
  },
  {
    "name": "userApi.Animals.editObject",
    "method": "PUT",
    "path": "/user/animals/{id}"
  },
  {
    "name": "userApi.Animals.getAllGroups",
    "method": "GET",
    "path": "/user/animals/groups"
  },
  {
    "name": "userApi.Animals.getAllObjectShares",
    "method": "POST",
    "path": "/user/animals/shares/get"
  },
  {
    "name": "userApi.Animals.getAllObjects",
    "method": "GET",
    "path": "/user/animals"
  },
  {
    "name": "userApi.Animals.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/animals/get"
  },
  {
    "name": "userApi.Animals.getCurrentCollarByAnimalId",
    "method": "GET",
    "path": "/user/animals/{animalId}/current-collar"
  },
  {
    "name": "userApi.Animals.getGroup",
    "method": "GET",
    "path": "/user/animals/groups/{id}"
  },
  {
    "name": "userApi.Animals.getGroupShares",
    "method": "GET",
    "path": "/user/animals/groups/{id}/shares"
  },
  {
    "name": "userApi.Animals.getMyRequestedShares",
    "method": "GET",
    "path": "/user/animals/shares/requests"
  },
  {
    "name": "userApi.Animals.getObject",
    "method": "GET",
    "path": "/user/animals/{id}"
  },
  {
    "name": "userApi.Animals.getObjectShares",
    "method": "GET",
    "path": "/user/animals/{id}/shares"
  },
  {
    "name": "userApi.Animals.passOwnership",
    "method": "POST",
    "path": "/user/animals/pass-ownership"
  },
  {
    "name": "userApi.Animals.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/animals/send-permission-request"
  },
  {
    "name": "userApi.Animals.updateGroupShares",
    "method": "PUT",
    "path": "/user/animals/groups/{id}/shares"
  },
  {
    "name": "userApi.Animals.updateObjectShares",
    "method": "PUT",
    "path": "/user/animals/{id}/shares"
  },
  {
    "name": "userApi.Animals.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/animals/shares/requests/withdraw"
  },
  {
    "name": "userApi.Cameras.addObjectShares",
    "method": "POST",
    "path": "/user/cameras/{id}/shares"
  },
  {
    "name": "userApi.Cameras.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/cameras/shares"
  },
  {
    "name": "userApi.Cameras.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/cameras/multiple/deletion"
  },
  {
    "name": "userApi.Cameras.deleteObject",
    "method": "DELETE",
    "path": "/user/cameras/{id}"
  },
  {
    "name": "userApi.Cameras.deleteObjectShares",
    "method": "POST",
    "path": "/user/cameras/{id}/shares/delete"
  },
  {
    "name": "userApi.Cameras.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/cameras/shares/delete"
  },
  {
    "name": "userApi.Cameras.denyRequestedShares",
    "method": "POST",
    "path": "/user/cameras/shares/requests/deny"
  },
  {
    "name": "userApi.Cameras.editObject",
    "method": "PUT",
    "path": "/user/cameras/{id}"
  },
  {
    "name": "userApi.Cameras.getAllObjectShares",
    "method": "POST",
    "path": "/user/cameras/shares/get"
  },
  {
    "name": "userApi.Cameras.getAllObjects",
    "method": "GET",
    "path": "/user/cameras"
  },
  {
    "name": "userApi.Cameras.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/cameras/get"
  },
  {
    "name": "userApi.Cameras.getMyRequestedShares",
    "method": "GET",
    "path": "/user/cameras/shares/requests"
  },
  {
    "name": "userApi.Cameras.getObject",
    "method": "GET",
    "path": "/user/cameras/{id}"
  },
  {
    "name": "userApi.Cameras.getObjectShares",
    "method": "GET",
    "path": "/user/cameras/{id}/shares"
  },
  {
    "name": "userApi.Cameras.passOwnership",
    "method": "POST",
    "path": "/user/cameras/pass-ownership"
  },
  {
    "name": "userApi.Cameras.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/cameras/send-permission-request"
  },
  {
    "name": "userApi.Cameras.updateObjectShares",
    "method": "PUT",
    "path": "/user/cameras/{id}/shares"
  },
  {
    "name": "userApi.Cameras.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/cameras/shares/requests/withdraw"
  },
  {
    "name": "userApi.Collars.addGroup",
    "method": "POST",
    "path": "/user/collars/groups"
  },
  {
    "name": "userApi.Collars.addGroupShares",
    "method": "POST",
    "path": "/user/collars/groups/{id}/shares"
  },
  {
    "name": "userApi.Collars.addObject",
    "method": "POST",
    "path": "/user/collars"
  },
  {
    "name": "userApi.Collars.addObjectShares",
    "method": "POST",
    "path": "/user/collars/{id}/shares"
  },
  {
    "name": "userApi.Collars.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/collars/shares"
  },
  {
    "name": "userApi.Collars.deleteGroup",
    "method": "DELETE",
    "path": "/user/collars/groups/{id}"
  },
  {
    "name": "userApi.Collars.deleteGroupShares",
    "method": "POST",
    "path": "/user/collars/groups/{id}/shares/delete"
  },
  {
    "name": "userApi.Collars.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/collars/multiple/deletion"
  },
  {
    "name": "userApi.Collars.deleteObject",
    "method": "DELETE",
    "path": "/user/collars/{id}"
  },
  {
    "name": "userApi.Collars.deleteObjectShares",
    "method": "POST",
    "path": "/user/collars/{id}/shares/delete"
  },
  {
    "name": "userApi.Collars.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/collars/shares/delete"
  },
  {
    "name": "userApi.Collars.denyRequestedShares",
    "method": "POST",
    "path": "/user/collars/shares/requests/deny"
  },
  {
    "name": "userApi.Collars.editGroup",
    "method": "PUT",
    "path": "/user/collars/groups/{id}"
  },
  {
    "name": "userApi.Collars.editObject",
    "method": "PUT",
    "path": "/user/collars/{id}"
  },
  {
    "name": "userApi.Collars.getAllGroups",
    "method": "GET",
    "path": "/user/collars/groups"
  },
  {
    "name": "userApi.Collars.getAllObjectShares",
    "method": "POST",
    "path": "/user/collars/shares/get"
  },
  {
    "name": "userApi.Collars.getAllObjects",
    "method": "GET",
    "path": "/user/collars"
  },
  {
    "name": "userApi.Collars.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/collars/get"
  },
  {
    "name": "userApi.Collars.getGroup",
    "method": "GET",
    "path": "/user/collars/groups/{id}"
  },
  {
    "name": "userApi.Collars.getGroupShares",
    "method": "GET",
    "path": "/user/collars/groups/{id}/shares"
  },
  {
    "name": "userApi.Collars.getMyRequestedShares",
    "method": "GET",
    "path": "/user/collars/shares/requests"
  },
  {
    "name": "userApi.Collars.getObject",
    "method": "GET",
    "path": "/user/collars/{id}"
  },
  {
    "name": "userApi.Collars.getObjectShares",
    "method": "GET",
    "path": "/user/collars/{id}/shares"
  },
  {
    "name": "userApi.Collars.passOwnership",
    "method": "POST",
    "path": "/user/collars/pass-ownership"
  },
  {
    "name": "userApi.Collars.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/collars/send-permission-request"
  },
  {
    "name": "userApi.Collars.updateGroupShares",
    "method": "PUT",
    "path": "/user/collars/groups/{id}/shares"
  },
  {
    "name": "userApi.Collars.updateObjectShares",
    "method": "PUT",
    "path": "/user/collars/{id}/shares"
  },
  {
    "name": "userApi.Collars.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/collars/shares/requests/withdraw"
  },
  {
    "name": "userApi.ConfigurationDevices.addObjectShares",
    "method": "POST",
    "path": "/user/configuration-devices/{id}/shares"
  },
  {
    "name": "userApi.ConfigurationDevices.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/configuration-devices/shares"
  },
  {
    "name": "userApi.ConfigurationDevices.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/configuration-devices/multiple/deletion"
  },
  {
    "name": "userApi.ConfigurationDevices.deleteObject",
    "method": "DELETE",
    "path": "/user/configuration-devices/{id}"
  },
  {
    "name": "userApi.ConfigurationDevices.deleteObjectShares",
    "method": "POST",
    "path": "/user/configuration-devices/{id}/shares/delete"
  },
  {
    "name": "userApi.ConfigurationDevices.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/configuration-devices/shares/delete"
  },
  {
    "name": "userApi.ConfigurationDevices.denyRequestedShares",
    "method": "POST",
    "path": "/user/configuration-devices/shares/requests/deny"
  },
  {
    "name": "userApi.ConfigurationDevices.editObject",
    "method": "PUT",
    "path": "/user/configuration-devices/{id}"
  },
  {
    "name": "userApi.ConfigurationDevices.getAllObjectShares",
    "method": "POST",
    "path": "/user/configuration-devices/shares/get"
  },
  {
    "name": "userApi.ConfigurationDevices.getAllObjects",
    "method": "GET",
    "path": "/user/configuration-devices"
  },
  {
    "name": "userApi.ConfigurationDevices.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/configuration-devices/get"
  },
  {
    "name": "userApi.ConfigurationDevices.getMyRequestedShares",
    "method": "GET",
    "path": "/user/configuration-devices/shares/requests"
  },
  {
    "name": "userApi.ConfigurationDevices.getObject",
    "method": "GET",
    "path": "/user/configuration-devices/{id}"
  },
  {
    "name": "userApi.ConfigurationDevices.getObjectShares",
    "method": "GET",
    "path": "/user/configuration-devices/{id}/shares"
  },
  {
    "name": "userApi.ConfigurationDevices.passOwnership",
    "method": "POST",
    "path": "/user/configuration-devices/pass-ownership"
  },
  {
    "name": "userApi.ConfigurationDevices.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/configuration-devices/send-permission-request"
  },
  {
    "name": "userApi.ConfigurationDevices.updateObjectShares",
    "method": "PUT",
    "path": "/user/configuration-devices/{id}/shares"
  },
  {
    "name": "userApi.ConfigurationDevices.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/configuration-devices/shares/requests/withdraw"
  },
  {
    "name": "userApi.DataLoggers.addObjectShares",
    "method": "POST",
    "path": "/user/data-loggers/{id}/shares"
  },
  {
    "name": "userApi.DataLoggers.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/data-loggers/shares"
  },
  {
    "name": "userApi.DataLoggers.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/data-loggers/multiple/deletion"
  },
  {
    "name": "userApi.DataLoggers.deleteObject",
    "method": "DELETE",
    "path": "/user/data-loggers/{id}"
  },
  {
    "name": "userApi.DataLoggers.deleteObjectShares",
    "method": "POST",
    "path": "/user/data-loggers/{id}/shares/delete"
  },
  {
    "name": "userApi.DataLoggers.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/data-loggers/shares/delete"
  },
  {
    "name": "userApi.DataLoggers.denyRequestedShares",
    "method": "POST",
    "path": "/user/data-loggers/shares/requests/deny"
  },
  {
    "name": "userApi.DataLoggers.editObject",
    "method": "PUT",
    "path": "/user/data-loggers/{id}"
  },
  {
    "name": "userApi.DataLoggers.getAllObjectShares",
    "method": "POST",
    "path": "/user/data-loggers/shares/get"
  },
  {
    "name": "userApi.DataLoggers.getAllObjects",
    "method": "GET",
    "path": "/user/data-loggers"
  },
  {
    "name": "userApi.DataLoggers.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/data-loggers/get"
  },
  {
    "name": "userApi.DataLoggers.getMyRequestedShares",
    "method": "GET",
    "path": "/user/data-loggers/shares/requests"
  },
  {
    "name": "userApi.DataLoggers.getObject",
    "method": "GET",
    "path": "/user/data-loggers/{id}"
  },
  {
    "name": "userApi.DataLoggers.getObjectShares",
    "method": "GET",
    "path": "/user/data-loggers/{id}/shares"
  },
  {
    "name": "userApi.DataLoggers.passOwnership",
    "method": "POST",
    "path": "/user/data-loggers/pass-ownership"
  },
  {
    "name": "userApi.DataLoggers.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/data-loggers/send-permission-request"
  },
  {
    "name": "userApi.DataLoggers.updateObjectShares",
    "method": "PUT",
    "path": "/user/data-loggers/{id}/shares"
  },
  {
    "name": "userApi.DataLoggers.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/data-loggers/shares/requests/withdraw"
  },
  {
    "name": "userApi.Deployments.addDeploymentToAnimal",
    "method": "POST",
    "path": "/user/animals/{animalId}/deployments"
  },
  {
    "name": "userApi.Deployments.deleteDeployment",
    "method": "DELETE",
    "path": "/user/deployments/{id}"
  },
  {
    "name": "userApi.Deployments.getActiveDeploymentByAnimalId",
    "method": "GET",
    "path": "/user/animals/{animalId}/deployments/active-deployment"
  },
  {
    "name": "userApi.Deployments.getActiveDeploymentByCollarId",
    "method": "GET",
    "path": "/user/collars/{collarId}/deployments/active-deployment"
  },
  {
    "name": "userApi.Deployments.getAllDeployments",
    "method": "GET",
    "path": "/user/deployments"
  },
  {
    "name": "userApi.Deployments.getDeploymentById",
    "method": "GET",
    "path": "/user/deployments/{id}"
  },
  {
    "name": "userApi.Deployments.getDeploymentsByAnimalId",
    "method": "GET",
    "path": "/user/animals/{animalId}/deployments"
  },
  {
    "name": "userApi.Deployments.getDeploymentsByCollarId",
    "method": "GET",
    "path": "/user/collars/{collarId}/deployments"
  },
  {
    "name": "userApi.Deployments.patchDeployment",
    "method": "PATCH",
    "path": "/user/deployments/{id}"
  },
  {
    "name": "userApi.Deployments.requestForDeploymentByAnimalId",
    "method": "POST",
    "path": "/user/animals/{animalId}/deployments/request-for-deployment"
  },
  {
    "name": "userApi.Deployments.updateDeployment",
    "method": "PUT",
    "path": "/user/deployments/{id}"
  },
  {
    "name": "userApi.DropOffs.addObjectShares",
    "method": "POST",
    "path": "/user/drop-offs/{id}/shares"
  },
  {
    "name": "userApi.DropOffs.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/drop-offs/shares"
  },
  {
    "name": "userApi.DropOffs.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/drop-offs/multiple/deletion"
  },
  {
    "name": "userApi.DropOffs.deleteObject",
    "method": "DELETE",
    "path": "/user/drop-offs/{id}"
  },
  {
    "name": "userApi.DropOffs.deleteObjectShares",
    "method": "POST",
    "path": "/user/drop-offs/{id}/shares/delete"
  },
  {
    "name": "userApi.DropOffs.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/drop-offs/shares/delete"
  },
  {
    "name": "userApi.DropOffs.denyRequestedShares",
    "method": "POST",
    "path": "/user/drop-offs/shares/requests/deny"
  },
  {
    "name": "userApi.DropOffs.editObject",
    "method": "PUT",
    "path": "/user/drop-offs/{id}"
  },
  {
    "name": "userApi.DropOffs.getAllObjectShares",
    "method": "POST",
    "path": "/user/drop-offs/shares/get"
  },
  {
    "name": "userApi.DropOffs.getAllObjects",
    "method": "GET",
    "path": "/user/drop-offs"
  },
  {
    "name": "userApi.DropOffs.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/drop-offs/get"
  },
  {
    "name": "userApi.DropOffs.getMyRequestedShares",
    "method": "GET",
    "path": "/user/drop-offs/shares/requests"
  },
  {
    "name": "userApi.DropOffs.getObject",
    "method": "GET",
    "path": "/user/drop-offs/{id}"
  },
  {
    "name": "userApi.DropOffs.getObjectShares",
    "method": "GET",
    "path": "/user/drop-offs/{id}/shares"
  },
  {
    "name": "userApi.DropOffs.passOwnership",
    "method": "POST",
    "path": "/user/drop-offs/pass-ownership"
  },
  {
    "name": "userApi.DropOffs.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/drop-offs/send-permission-request"
  },
  {
    "name": "userApi.DropOffs.updateObjectShares",
    "method": "PUT",
    "path": "/user/drop-offs/{id}/shares"
  },
  {
    "name": "userApi.DropOffs.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/drop-offs/shares/requests/withdraw"
  },
  {
    "name": "userApi.ESRIIdentity.deleteSession",
    "method": "DELETE",
    "path": "/user/esri/session"
  },
  {
    "name": "userApi.ESRIIdentity.exchange",
    "method": "POST",
    "path": "/user/esri/exchange"
  },
  {
    "name": "userApi.ESRIIdentity.getAccessToken",
    "method": "GET",
    "path": "/user/esri/token"
  },
  {
    "name": "userApi.ESRIIdentity.getFeatureLayers",
    "method": "GET",
    "path": "/user/esri/feature-layers"
  },
  {
    "name": "userApi.ESRIIdentity.getSession",
    "method": "GET",
    "path": "/user/esri/session"
  },
  {
    "name": "userApi.ExternalSensors.addObjectShares",
    "method": "POST",
    "path": "/user/external-sensors/{id}/shares"
  },
  {
    "name": "userApi.ExternalSensors.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/external-sensors/shares"
  },
  {
    "name": "userApi.ExternalSensors.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/external-sensors/multiple/deletion"
  },
  {
    "name": "userApi.ExternalSensors.deleteObject",
    "method": "DELETE",
    "path": "/user/external-sensors/{id}"
  },
  {
    "name": "userApi.ExternalSensors.deleteObjectShares",
    "method": "POST",
    "path": "/user/external-sensors/{id}/shares/delete"
  },
  {
    "name": "userApi.ExternalSensors.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/external-sensors/shares/delete"
  },
  {
    "name": "userApi.ExternalSensors.denyRequestedShares",
    "method": "POST",
    "path": "/user/external-sensors/shares/requests/deny"
  },
  {
    "name": "userApi.ExternalSensors.editObject",
    "method": "PUT",
    "path": "/user/external-sensors/{id}"
  },
  {
    "name": "userApi.ExternalSensors.getAllObjectShares",
    "method": "POST",
    "path": "/user/external-sensors/shares/get"
  },
  {
    "name": "userApi.ExternalSensors.getAllObjects",
    "method": "GET",
    "path": "/user/external-sensors"
  },
  {
    "name": "userApi.ExternalSensors.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/external-sensors/get"
  },
  {
    "name": "userApi.ExternalSensors.getMyRequestedShares",
    "method": "GET",
    "path": "/user/external-sensors/shares/requests"
  },
  {
    "name": "userApi.ExternalSensors.getObject",
    "method": "GET",
    "path": "/user/external-sensors/{id}"
  },
  {
    "name": "userApi.ExternalSensors.getObjectShares",
    "method": "GET",
    "path": "/user/external-sensors/{id}/shares"
  },
  {
    "name": "userApi.ExternalSensors.passOwnership",
    "method": "POST",
    "path": "/user/external-sensors/pass-ownership"
  },
  {
    "name": "userApi.ExternalSensors.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/external-sensors/send-permission-request"
  },
  {
    "name": "userApi.ExternalSensors.updateObjectShares",
    "method": "PUT",
    "path": "/user/external-sensors/{id}/shares"
  },
  {
    "name": "userApi.ExternalSensors.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/external-sensors/shares/requests/withdraw"
  },
  {
    "name": "userApi.JSONLogs.addJsonLog",
    "method": "POST",
    "path": "/user/json-logs"
  },
  {
    "name": "userApi.ReportIssues.reportIssue",
    "method": "POST",
    "path": "/user/report-issue"
  },
  {
    "name": "userApi.StoredFilters.addFilter",
    "method": "POST",
    "path": "/user/filter-storage"
  },
  {
    "name": "userApi.StoredFilters.deleteFilter",
    "method": "DELETE",
    "path": "/user/filter-storage/{id}"
  },
  {
    "name": "userApi.StoredFilters.editFilter",
    "method": "PUT",
    "path": "/user/filter-storage/{id}"
  },
  {
    "name": "userApi.StoredFilters.getFilters",
    "method": "GET",
    "path": "/user/filter-storage"
  },
  {
    "name": "userApi.TT4Sensors.addObjectShares",
    "method": "POST",
    "path": "/user/tt4-sensors/{id}/shares"
  },
  {
    "name": "userApi.TT4Sensors.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/tt4-sensors/shares"
  },
  {
    "name": "userApi.TT4Sensors.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/tt4-sensors/multiple/deletion"
  },
  {
    "name": "userApi.TT4Sensors.deleteObject",
    "method": "DELETE",
    "path": "/user/tt4-sensors/{id}"
  },
  {
    "name": "userApi.TT4Sensors.deleteObjectShares",
    "method": "POST",
    "path": "/user/tt4-sensors/{id}/shares/delete"
  },
  {
    "name": "userApi.TT4Sensors.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/tt4-sensors/shares/delete"
  },
  {
    "name": "userApi.TT4Sensors.denyRequestedShares",
    "method": "POST",
    "path": "/user/tt4-sensors/shares/requests/deny"
  },
  {
    "name": "userApi.TT4Sensors.editObject",
    "method": "PUT",
    "path": "/user/tt4-sensors/{id}"
  },
  {
    "name": "userApi.TT4Sensors.getAllObjectShares",
    "method": "POST",
    "path": "/user/tt4-sensors/shares/get"
  },
  {
    "name": "userApi.TT4Sensors.getAllObjects",
    "method": "GET",
    "path": "/user/tt4-sensors"
  },
  {
    "name": "userApi.TT4Sensors.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/tt4-sensors/get"
  },
  {
    "name": "userApi.TT4Sensors.getMyRequestedShares",
    "method": "GET",
    "path": "/user/tt4-sensors/shares/requests"
  },
  {
    "name": "userApi.TT4Sensors.getObject",
    "method": "GET",
    "path": "/user/tt4-sensors/{id}"
  },
  {
    "name": "userApi.TT4Sensors.getObjectShares",
    "method": "GET",
    "path": "/user/tt4-sensors/{id}/shares"
  },
  {
    "name": "userApi.TT4Sensors.passOwnership",
    "method": "POST",
    "path": "/user/tt4-sensors/pass-ownership"
  },
  {
    "name": "userApi.TT4Sensors.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/tt4-sensors/send-permission-request"
  },
  {
    "name": "userApi.TT4Sensors.updateObjectShares",
    "method": "PUT",
    "path": "/user/tt4-sensors/{id}/shares"
  },
  {
    "name": "userApi.TT4Sensors.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/tt4-sensors/shares/requests/withdraw"
  },
  {
    "name": "userApi.Traps.addGroup",
    "method": "POST",
    "path": "/user/traps/groups"
  },
  {
    "name": "userApi.Traps.addGroupShares",
    "method": "POST",
    "path": "/user/traps/groups/{id}/shares"
  },
  {
    "name": "userApi.Traps.addObject",
    "method": "POST",
    "path": "/user/traps"
  },
  {
    "name": "userApi.Traps.addObjectShares",
    "method": "POST",
    "path": "/user/traps/{id}/shares"
  },
  {
    "name": "userApi.Traps.addSharesToMultipleObjects",
    "method": "POST",
    "path": "/user/traps/shares"
  },
  {
    "name": "userApi.Traps.deleteGroup",
    "method": "DELETE",
    "path": "/user/traps/groups/{id}"
  },
  {
    "name": "userApi.Traps.deleteGroupShares",
    "method": "POST",
    "path": "/user/traps/groups/{id}/shares/delete"
  },
  {
    "name": "userApi.Traps.deleteMultipleObjects",
    "method": "POST",
    "path": "/user/traps/multiple/deletion"
  },
  {
    "name": "userApi.Traps.deleteObject",
    "method": "DELETE",
    "path": "/user/traps/{id}"
  },
  {
    "name": "userApi.Traps.deleteObjectShares",
    "method": "POST",
    "path": "/user/traps/{id}/shares/delete"
  },
  {
    "name": "userApi.Traps.deleteSharesForMultipleObjects",
    "method": "POST",
    "path": "/user/traps/shares/delete"
  },
  {
    "name": "userApi.Traps.denyRequestedShares",
    "method": "POST",
    "path": "/user/traps/shares/requests/deny"
  },
  {
    "name": "userApi.Traps.editGroup",
    "method": "PUT",
    "path": "/user/traps/groups/{id}"
  },
  {
    "name": "userApi.Traps.editObject",
    "method": "PUT",
    "path": "/user/traps/{id}"
  },
  {
    "name": "userApi.Traps.getAllGroups",
    "method": "GET",
    "path": "/user/traps/groups"
  },
  {
    "name": "userApi.Traps.getAllObjectShares",
    "method": "POST",
    "path": "/user/traps/shares/get"
  },
  {
    "name": "userApi.Traps.getAllObjects",
    "method": "GET",
    "path": "/user/traps"
  },
  {
    "name": "userApi.Traps.getAllObjectsWithFilterInBody",
    "method": "POST",
    "path": "/user/traps/get"
  },
  {
    "name": "userApi.Traps.getGroup",
    "method": "GET",
    "path": "/user/traps/groups/{id}"
  },
  {
    "name": "userApi.Traps.getGroupShares",
    "method": "GET",
    "path": "/user/traps/groups/{id}/shares"
  },
  {
    "name": "userApi.Traps.getMyRequestedShares",
    "method": "GET",
    "path": "/user/traps/shares/requests"
  },
  {
    "name": "userApi.Traps.getObject",
    "method": "GET",
    "path": "/user/traps/{id}"
  },
  {
    "name": "userApi.Traps.getObjectShares",
    "method": "GET",
    "path": "/user/traps/{id}/shares"
  },
  {
    "name": "userApi.Traps.passOwnership",
    "method": "POST",
    "path": "/user/traps/pass-ownership"
  },
  {
    "name": "userApi.Traps.sendPermissionRequestsForDevices",
    "method": "POST",
    "path": "/user/traps/send-permission-request"
  },
  {
    "name": "userApi.Traps.updateGroupShares",
    "method": "PUT",
    "path": "/user/traps/groups/{id}/shares"
  },
  {
    "name": "userApi.Traps.updateObjectShares",
    "method": "PUT",
    "path": "/user/traps/{id}/shares"
  },
  {
    "name": "userApi.Traps.withdrawRequestedShares",
    "method": "POST",
    "path": "/user/traps/shares/requests/withdraw"
  },
  {
    "name": "userApi.VirtualFence.addVirtualFence",
    "method": "POST",
    "path": "/user/virtual-fences"
  },
  {
    "name": "userApi.VirtualFence.deleteVirtualFence",
    "method": "DELETE",
    "path": "/user/virtual-fences/{id}"
  },
  {
    "name": "userApi.VirtualFence.editVirtualFence",
    "method": "PUT",
    "path": "/user/virtual-fences/{id}"
  },
  {
    "name": "userApi.VirtualFence.findVirtualFence",
    "method": "POST",
    "path": "/user/virtual-fences/find-virtual-fence"
  },
  {
    "name": "userApi.VirtualFence.getVirtualFences",
    "method": "GET",
    "path": "/user/virtual-fences"
  },
  {
    "name": "selectionApi.GroupSelection.getSelectedAnimalGroupId",
    "method": "GET",
    "path": "/selection/groups/animal-group"
  },
  {
    "name": "selectionApi.GroupSelection.getSelectedCollarGroupId",
    "method": "GET",
    "path": "/selection/groups/collar-group"
  },
  {
    "name": "selectionApi.GroupSelection.setSelectedAnimalGroupId",
    "method": "PUT",
    "path": "/selection/groups/animal-group"
  },
  {
    "name": "selectionApi.GroupSelection.setSelectedCollarGroupId",
    "method": "PUT",
    "path": "/selection/groups/collar-group"
  },
  {
    "name": "selectionApi.Selection.getUserSelection",
    "method": "GET",
    "path": "/selection/"
  },
  {
    "name": "selectionApi.TreeviewSelection.getSelectedNodes",
    "method": "GET",
    "path": "/selection/treeview/nodes"
  },
  {
    "name": "selectionApi.TreeviewSelection.getSelectedTreeviewTab",
    "method": "GET",
    "path": "/selection/treeview/tab"
  },
  {
    "name": "selectionApi.TreeviewSelection.setSelectedTreeviewTab",
    "method": "PUT",
    "path": "/selection/treeview/tab"
  },
  {
    "name": "selectionApi.TreeviewSelection.setTreeviewSelection",
    "method": "PUT",
    "path": "/selection/treeview/nodes"
  },
  {
    "name": "webApi.Activities.getCount",
    "method": "POST",
    "path": "/web/events/act/get-count"
  },
  {
    "name": "webApi.Activities.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/act/get-count-by-animals"
  },
  {
    "name": "webApi.Activities.getData",
    "method": "POST",
    "path": "/web/events/act/get-data"
  },
  {
    "name": "webApi.Activities.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/act/get-data-by-animals"
  },
  {
    "name": "webApi.Animals.getAnimalDashboard",
    "method": "GET",
    "path": "/web/animals/dashboard"
  },
  {
    "name": "webApi.Animals.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/animals"
  },
  {
    "name": "webApi.Animals.getEventDetails",
    "method": "GET",
    "path": "/web/animals/{animalId}/event-details"
  },
  {
    "name": "webApi.Cameras.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/cameras/get-available-device-type-features"
  },
  {
    "name": "webApi.Cameras.getById",
    "method": "GET",
    "path": "/web/devices/cameras/{id}"
  },
  {
    "name": "webApi.Cameras.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/cameras"
  },
  {
    "name": "webApi.Cameras.update",
    "method": "PUT",
    "path": "/web/devices/cameras/{id}"
  },
  {
    "name": "webApi.CollarLogs.getCount",
    "method": "POST",
    "path": "/web/events/clg/get-count"
  },
  {
    "name": "webApi.CollarLogs.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/clg/get-count-by-animals"
  },
  {
    "name": "webApi.CollarLogs.getData",
    "method": "POST",
    "path": "/web/events/clg/get-data"
  },
  {
    "name": "webApi.CollarLogs.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/clg/get-data-by-animals"
  },
  {
    "name": "webApi.Collars.activateDevicesFromInventa",
    "method": "POST",
    "path": "/web/devices/collars/inventa/activate-devices"
  },
  {
    "name": "webApi.Collars.activateDevicesFromMyVectronic",
    "method": "POST",
    "path": "/web/devices/collars/my-vectronic/activate-devices"
  },
  {
    "name": "webApi.Collars.add",
    "method": "POST",
    "path": "/web/devices/collars"
  },
  {
    "name": "webApi.Collars.deactivateDevicesFromInventa",
    "method": "POST",
    "path": "/web/devices/collars/inventa/deactivate-devices"
  },
  {
    "name": "webApi.Collars.deactivateDevicesFromMyVectronic",
    "method": "POST",
    "path": "/web/devices/collars/my-vectronic/deactivate-devices"
  },
  {
    "name": "webApi.Collars.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/collars/get-available-device-type-features"
  },
  {
    "name": "webApi.Collars.getById",
    "method": "GET",
    "path": "/web/devices/collars/{id}"
  },
  {
    "name": "webApi.Collars.getCollarDashboard",
    "method": "GET",
    "path": "/web/devices/collars/dashboard"
  },
  {
    "name": "webApi.Collars.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/collars"
  },
  {
    "name": "webApi.Collars.getEventDetails",
    "method": "GET",
    "path": "/web/devices/collars/{collarId}/event-details"
  },
  {
    "name": "webApi.Collars.getRemoteDeviceCommandsByDeviceIds",
    "method": "GET",
    "path": "/web/devices/collars/get-remote-device-commands"
  },
  {
    "name": "webApi.Collars.getRemoteParametersByDeviceIds",
    "method": "GET",
    "path": "/web/devices/collars/get-remote-parameters"
  },
  {
    "name": "webApi.Collars.getRemoteSchedulesByDeviceIds",
    "method": "GET",
    "path": "/web/devices/collars/get-remote-schedules"
  },
  {
    "name": "webApi.Collars.getSharedMotionFileDownloadUrl",
    "method": "GET",
    "path": "/web/devices/collars/shared-motion-files/{fileName}/download-url"
  },
  {
    "name": "webApi.Collars.getSharedMotionFiles",
    "method": "GET",
    "path": "/web/devices/collars/shared-motion-files"
  },
  {
    "name": "webApi.Collars.update",
    "method": "PUT",
    "path": "/web/devices/collars/{id}"
  },
  {
    "name": "webApi.Commands.addOfflineCommand",
    "method": "POST",
    "path": "/web/commands/offline"
  },
  {
    "name": "webApi.Commands.addRemoteCommand",
    "method": "POST",
    "path": "/web/commands/remote"
  },
  {
    "name": "webApi.Commands.cancelRemoteCommand",
    "method": "POST",
    "path": "/web/commands/remote/cancel"
  },
  {
    "name": "webApi.Commands.getCommands",
    "method": "POST",
    "path": "/web/commands"
  },
  {
    "name": "webApi.Commands.getCommandsCount",
    "method": "POST",
    "path": "/web/commands/count"
  },
  {
    "name": "webApi.Commands.validateRemoteCommand",
    "method": "POST",
    "path": "/web/commands/remote/validate"
  },
  {
    "name": "webApi.ConfigurationDevices.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/configuration-devices/get-available-device-type-features"
  },
  {
    "name": "webApi.ConfigurationDevices.getById",
    "method": "GET",
    "path": "/web/devices/configuration-devices/{id}"
  },
  {
    "name": "webApi.ConfigurationDevices.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/configuration-devices"
  },
  {
    "name": "webApi.ConfigurationDevices.update",
    "method": "PUT",
    "path": "/web/devices/configuration-devices/{id}"
  },
  {
    "name": "webApi.DataLoggers.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/data-loggers/get-available-device-type-features"
  },
  {
    "name": "webApi.DataLoggers.getById",
    "method": "GET",
    "path": "/web/devices/data-loggers/{id}"
  },
  {
    "name": "webApi.DataLoggers.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/data-loggers"
  },
  {
    "name": "webApi.DataLoggers.update",
    "method": "PUT",
    "path": "/web/devices/data-loggers/{id}"
  },
  {
    "name": "webApi.DropOffs.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/drop-offs/get-available-device-type-features"
  },
  {
    "name": "webApi.DropOffs.getById",
    "method": "GET",
    "path": "/web/devices/drop-offs/{id}"
  },
  {
    "name": "webApi.DropOffs.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/drop-offs"
  },
  {
    "name": "webApi.DropOffs.update",
    "method": "PUT",
    "path": "/web/devices/drop-offs/{id}"
  },
  {
    "name": "webApi.ESRI.addDeviceToEsriProject",
    "method": "PUT",
    "path": "/web/esri/add-device"
  },
  {
    "name": "webApi.ESRI.addEsriProject",
    "method": "POST",
    "path": "/web/esri"
  },
  {
    "name": "webApi.ESRI.changeEsriProjectUrl",
    "method": "PUT",
    "path": "/web/esri/change-url"
  },
  {
    "name": "webApi.ESRI.deleteDeviceFromEsriProject",
    "method": "DELETE",
    "path": "/web/esri/delete-device"
  },
  {
    "name": "webApi.ESRI.deleteEsriProject",
    "method": "DELETE",
    "path": "/web/esri"
  },
  {
    "name": "webApi.ESRI.getEsriProject",
    "method": "GET",
    "path": "/web/esri"
  },
  {
    "name": "webApi.ExternalSensors.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/external-sensors/get-available-device-type-features"
  },
  {
    "name": "webApi.ExternalSensors.getById",
    "method": "GET",
    "path": "/web/devices/external-sensors/{id}"
  },
  {
    "name": "webApi.ExternalSensors.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/external-sensors"
  },
  {
    "name": "webApi.ExternalSensors.update",
    "method": "PUT",
    "path": "/web/devices/external-sensors/{id}"
  },
  {
    "name": "webApi.GPSPositions.getCount",
    "method": "POST",
    "path": "/web/events/gps/get-count"
  },
  {
    "name": "webApi.GPSPositions.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/gps/get-count-by-animals"
  },
  {
    "name": "webApi.GPSPositions.getData",
    "method": "POST",
    "path": "/web/events/gps/get-data"
  },
  {
    "name": "webApi.GPSPositions.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/gps/get-data-by-animals"
  },
  {
    "name": "webApi.GPSPositions.getMapPositions",
    "method": "POST",
    "path": "/web/events/gps/map/get-data"
  },
  {
    "name": "webApi.GPSPositions.getMapPositionsByAnimals",
    "method": "POST",
    "path": "/web/events/gps/map/get-data-by-animals"
  },
  {
    "name": "webApi.MarkerIcon.getIconByIdAndColor",
    "method": "GET",
    "path": "/web/icon/{id}"
  },
  {
    "name": "webApi.Mortalities.getCount",
    "method": "POST",
    "path": "/web/events/mor/get-count"
  },
  {
    "name": "webApi.Mortalities.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/mor/get-count-by-animals"
  },
  {
    "name": "webApi.Mortalities.getData",
    "method": "POST",
    "path": "/web/events/mor/get-data"
  },
  {
    "name": "webApi.Mortalities.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/mor/get-data-by-animals"
  },
  {
    "name": "webApi.MortalityImplants.getCount",
    "method": "POST",
    "path": "/web/events/mit/get-count"
  },
  {
    "name": "webApi.MortalityImplants.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/mit/get-count-by-animals"
  },
  {
    "name": "webApi.MortalityImplants.getData",
    "method": "POST",
    "path": "/web/events/mit/get-data"
  },
  {
    "name": "webApi.MortalityImplants.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/mit/get-data-by-animals"
  },
  {
    "name": "webApi.Movebank.activateForwardingForDevices",
    "method": "POST",
    "path": "/web/rest/movebank/account/forwarding-devices"
  },
  {
    "name": "webApi.Movebank.addAccount",
    "method": "POST",
    "path": "/web/rest/movebank/account"
  },
  {
    "name": "webApi.Movebank.deleteAccount",
    "method": "DELETE",
    "path": "/web/rest/movebank/account"
  },
  {
    "name": "webApi.Movebank.getAccount",
    "method": "GET",
    "path": "/web/rest/movebank/account"
  },
  {
    "name": "webApi.Movebank.getForwardingDevicesFromAccount",
    "method": "GET",
    "path": "/web/rest/movebank/account/forwarding-devices"
  },
  {
    "name": "webApi.Movebank.removeForwardingFromDevices",
    "method": "DELETE",
    "path": "/web/rest/movebank/account/forwarding-devices"
  },
  {
    "name": "webApi.Movebank.updateAccount",
    "method": "PATCH",
    "path": "/web/rest/movebank/account"
  },
  {
    "name": "webApi.Movebank.uploadAllDataForDevices",
    "method": "POST",
    "path": "/web/rest/movebank/dataupload/data"
  },
  {
    "name": "webApi.Notifications.addAddress",
    "method": "POST",
    "path": "/web/rest/notifications/addresses"
  },
  {
    "name": "webApi.Notifications.addRule",
    "method": "POST",
    "path": "/web/rest/notifications/rules"
  },
  {
    "name": "webApi.Notifications.deleteMultipleRules",
    "method": "POST",
    "path": "/web/rest/notifications/rules/delete-multiple"
  },
  {
    "name": "webApi.Notifications.deleteRule",
    "method": "DELETE",
    "path": "/web/rest/notifications/rules/{id}"
  },
  {
    "name": "webApi.Notifications.getRulesByDeviceId",
    "method": "GET",
    "path": "/web/rest/notifications/rules/device/{deviceId}"
  },
  {
    "name": "webApi.Notifications.getRulesByDeviceIds",
    "method": "POST",
    "path": "/web/rest/notifications/rules/get-by-devices"
  },
  {
    "name": "webApi.OldAnimals.addAnimal",
    "method": "POST",
    "path": "/web/rest/animals"
  },
  {
    "name": "webApi.OldAnimals.addAnimalGroup",
    "method": "POST",
    "path": "/web/rest/animals/groups"
  },
  {
    "name": "webApi.OldAnimals.getAllAnimalsWithAggregatedInformation",
    "method": "GET",
    "path": "/web/rest/animals"
  },
  {
    "name": "webApi.OldAnimals.getAnimalGroups",
    "method": "GET",
    "path": "/web/rest/animals/groups"
  },
  {
    "name": "webApi.OldCollars.addCollar",
    "method": "POST",
    "path": "/web/rest/collars"
  },
  {
    "name": "webApi.OldCollars.addCollarGroup",
    "method": "POST",
    "path": "/web/rest/collars/groups"
  },
  {
    "name": "webApi.OldCollars.getAllCollarGroups",
    "method": "GET",
    "path": "/web/rest/collars/groups"
  },
  {
    "name": "webApi.OldCollars.getAllCollarsWithAggregatedInformation",
    "method": "GET",
    "path": "/web/rest/collars"
  },
  {
    "name": "webApi.OldCollars.getCollarById",
    "method": "GET",
    "path": "/web/rest/collars/{collarId}"
  },
  {
    "name": "webApi.OldDeployments.createDeployment",
    "method": "POST",
    "path": "/web/rest/deployments/animals/{id}"
  },
  {
    "name": "webApi.OldDeployments.getDeployments",
    "method": "GET",
    "path": "/web/rest/deployments"
  },
  {
    "name": "webApi.OldDeployments.getOverlappingDeployments",
    "method": "POST",
    "path": "/web/rest/animals/{animalId}/deployments/request-for-deployment"
  },
  {
    "name": "webApi.PaymentInformation.addViewerOrFinancialToPaymentAccount",
    "method": "POST",
    "path": "/web/payment/account/{accountId}/add-role"
  },
  {
    "name": "webApi.PaymentInformation.deleteViewerOrFinancialToPaymentAccount",
    "method": "DELETE",
    "path": "/web/payment/account/{accountId}/delete-role/{email}"
  },
  {
    "name": "webApi.PaymentInformation.exportAirtimeCost",
    "method": "GET",
    "path": "/web/payment/{accountId}/export-airtime-cost"
  },
  {
    "name": "webApi.PaymentInformation.exportAirtimeCostCsvDeviceConnections",
    "method": "GET",
    "path": "/web/payment/{accountId}/export-airtime-cost-csv-device-connections"
  },
  {
    "name": "webApi.PaymentInformation.exportAirtimeCostCsvOverview",
    "method": "GET",
    "path": "/web/payment/{accountId}/export-airtime-cost-csv-overview"
  },
  {
    "name": "webApi.PaymentInformation.getAirtimeDevices",
    "method": "GET",
    "path": "/web/payment/devices"
  },
  {
    "name": "webApi.PaymentInformation.getDeviceConnections",
    "method": "GET",
    "path": "/web/payment/{accountId}/device-connections"
  },
  {
    "name": "webApi.PaymentInformation.getDeviceCost",
    "method": "GET",
    "path": "/web/payment/{accountId}/device-cost"
  },
  {
    "name": "webApi.PaymentInformation.getPaymentAccounts",
    "method": "GET",
    "path": "/web/payment/accounts"
  },
  {
    "name": "webApi.Proximities.getCount",
    "method": "POST",
    "path": "/web/events/prx/get-count"
  },
  {
    "name": "webApi.Proximities.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/prx/get-count-by-animals"
  },
  {
    "name": "webApi.Proximities.getData",
    "method": "POST",
    "path": "/web/events/prx/get-data"
  },
  {
    "name": "webApi.Proximities.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/prx/get-data-by-animals"
  },
  {
    "name": "webApi.ScheduleTemplates.addScheduleTemplate",
    "method": "POST",
    "path": "/web/schedule-templates"
  },
  {
    "name": "webApi.ScheduleTemplates.deleteScheduleTemplate",
    "method": "DELETE",
    "path": "/web/schedule-templates/{id}"
  },
  {
    "name": "webApi.ScheduleTemplates.editScheduleTemplate",
    "method": "PUT",
    "path": "/web/schedule-templates"
  },
  {
    "name": "webApi.ScheduleTemplates.getScheduleTemplates",
    "method": "GET",
    "path": "/web/schedule-templates"
  },
  {
    "name": "webApi.Separation.getCount",
    "method": "POST",
    "path": "/web/events/sep/get-count"
  },
  {
    "name": "webApi.Separation.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/sep/get-count-by-animals"
  },
  {
    "name": "webApi.Separation.getData",
    "method": "POST",
    "path": "/web/events/sep/get-data"
  },
  {
    "name": "webApi.Separation.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/sep/get-data-by-animals"
  },
  {
    "name": "webApi.TT4Sensors.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/tt4-sensors/get-available-device-type-features"
  },
  {
    "name": "webApi.TT4Sensors.getById",
    "method": "GET",
    "path": "/web/devices/tt4-sensors/{id}"
  },
  {
    "name": "webApi.TT4Sensors.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/tt4-sensors"
  },
  {
    "name": "webApi.TT4Sensors.update",
    "method": "PUT",
    "path": "/web/devices/tt4-sensors/{id}"
  },
  {
    "name": "webApi.TrapEvents.getCount",
    "method": "POST",
    "path": "/web/events/trap/get-count"
  },
  {
    "name": "webApi.TrapEvents.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/trap/get-count-by-animals"
  },
  {
    "name": "webApi.TrapEvents.getData",
    "method": "POST",
    "path": "/web/events/trap/get-data"
  },
  {
    "name": "webApi.TrapEvents.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/trap/get-data-by-animals"
  },
  {
    "name": "webApi.Traps.activateDevicesFromInventa",
    "method": "POST",
    "path": "/web/devices/traps/inventa/activate-devices"
  },
  {
    "name": "webApi.Traps.activateDevicesFromMyVectronic",
    "method": "POST",
    "path": "/web/devices/traps/my-vectronic/activate-devices"
  },
  {
    "name": "webApi.Traps.add",
    "method": "POST",
    "path": "/web/devices/traps"
  },
  {
    "name": "webApi.Traps.deactivateDevicesFromInventa",
    "method": "POST",
    "path": "/web/devices/traps/inventa/deactivate-devices"
  },
  {
    "name": "webApi.Traps.deactivateDevicesFromMyVectronic",
    "method": "POST",
    "path": "/web/devices/traps/my-vectronic/deactivate-devices"
  },
  {
    "name": "webApi.Traps.getAvailableDeviceFeatures",
    "method": "POST",
    "path": "/web/devices/traps/get-available-device-type-features"
  },
  {
    "name": "webApi.Traps.getById",
    "method": "GET",
    "path": "/web/devices/traps/{id}"
  },
  {
    "name": "webApi.Traps.getDataWithAggregatedInformation",
    "method": "GET",
    "path": "/web/devices/traps"
  },
  {
    "name": "webApi.Traps.update",
    "method": "PUT",
    "path": "/web/devices/traps/{id}"
  },
  {
    "name": "webApi.Users.amIAdmin",
    "method": "GET",
    "path": "/web/rest/am-i-admin"
  },
  {
    "name": "webApi.Users.createUser",
    "method": "POST",
    "path": "/web/rest/users"
  },
  {
    "name": "webApi.Users.editUser",
    "method": "PUT",
    "path": "/web/rest/users"
  },
  {
    "name": "webApi.Users.getMyEmail",
    "method": "GET",
    "path": "/web/rest/my-email"
  },
  {
    "name": "webApi.Users.getUser",
    "method": "GET",
    "path": "/web/rest/users"
  },
  {
    "name": "webApi.VaginalImplants.getCount",
    "method": "POST",
    "path": "/web/events/vit/get-count"
  },
  {
    "name": "webApi.VaginalImplants.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/vit/get-count-by-animals"
  },
  {
    "name": "webApi.VaginalImplants.getData",
    "method": "POST",
    "path": "/web/events/vit/get-data"
  },
  {
    "name": "webApi.VaginalImplants.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/vit/get-data-by-animals"
  },
  {
    "name": "webApi.VirtualFenceEvents.getCount",
    "method": "POST",
    "path": "/web/events/vfe/get-count"
  },
  {
    "name": "webApi.VirtualFenceEvents.getCountByAnimals",
    "method": "POST",
    "path": "/web/events/vfe/get-count-by-animals"
  },
  {
    "name": "webApi.VirtualFenceEvents.getData",
    "method": "POST",
    "path": "/web/events/vfe/get-data"
  },
  {
    "name": "webApi.VirtualFenceEvents.getDataByAnimals",
    "method": "POST",
    "path": "/web/events/vfe/get-data-by-animals"
  }
] as const
